export const git_env: { [s: string]: (string | null); } = {
  sha: "724e8ce"
}